module.exports = __webpack_public_path__ + "static/media/drl2.png.d0eedc23.jpg";